export const AUTH_INIT = 'AUTH_INIT';
export const AUTH_FAIL = 'AUTH_FAIL';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
